import { IGenericCmsPage } from "api/interfaces/static-pages/common.type";
import commonSectionStyles from "resources/common-css/commonSection.module.scss";
import commonTitleStyles from "resources/common-css/commonTitle.module.scss";
import { renderHTML } from "util/DomHelper";
import VizSensor from "../../component/design-system/VizSensor";
import LandingPageBanner from "../../component/landing-page/LandingPageBanner";
import { getRelativeImagePath } from "../../util/helper/getRelativeImagePath";
import styles from "./about-partsavatar.module.scss";

function AboutPartsAvatarItem({ contentId, htmlContent, htmlContent2 }) {
  switch (contentId) {
  case "about-partsavatar-canada-who-we-are":
  case "fr-about-partsavatar-canada-who-we-are":
    return (
      <div className="row">

        <div className="col-xs-12 col-md-6">
          <div dangerouslySetInnerHTML={renderHTML(htmlContent)} />
        </div>
        <VizSensor>

          <img
            alt="PartsAvatar"
            className="col-md-6 col-sm-12 col-xs-12"
            src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/banners/LOGO.png`}
          />
        </VizSensor>
      </div>
    );
  case "about-partsavatar-canada-our-network":
  case "fr-about-partsavatar-canada-our-network":

    return (
      <>
        <div dangerouslySetInnerHTML={renderHTML(htmlContent)} />
        <VizSensor>

          <img
            alt="AUTOPARTS"
            className="img-responsive center-block"
            style={{ marginBottom: "calc(2 * var(--safari-root-font, 10px))", width: "70%" }}
            src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/banners/AUTOPARTS.png`}
          />
        </VizSensor>
      </>
    );
  case "about-partsavatar-canada-msg-from-ceo":
  case "fr-about-partsavatar-canada-msg-from-ceo":
    return (
      <div className="row">

        <div className="col-md-6">
          <div dangerouslySetInnerHTML={renderHTML(htmlContent)} />
        </div>

        <div className="col-md-6">
          <div dangerouslySetInnerHTML={renderHTML(htmlContent2)} />
        </div>
      </div>
    );
  case "about-partsavatar-canada-feedback":
  case "fr-about-partsavatar-canada-feedback":
    return (
      <div className="row">

        <VizSensor>

          <img
            alt="CUSTOMER-CHATS"
            className="col-md-6 col-sm-12 col-xs-12"
            src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/banners/CUSTOMER-CHATS.png`}
          />
        </VizSensor>

        <div className="col-md-6 col-sm-12 col-xs-12">

          <div>
            <div dangerouslySetInnerHTML={renderHTML(htmlContent)} />
          </div>
        </div>
      </div>
    );
  default:
    return null;
  }
}

function AboutPartsAvatar(props: IGenericCmsPage) {
  const { headers, links } = props.actualResponse.landingPage;
  const { h1: heading } = headers;
  const { contentIds } = links;

  function isCEOMsgContent(contentId) {
    return ["about-partsavatar-canada-msg-from-ceo-2", "fr-about-partsavatar-canada-msg-from-ceo-2"].includes(contentId);
  }

  let updatedContentIds = contentIds.filter((eachContent) => {
    const { url: contentId } = eachContent;
    if (isCEOMsgContent(contentId)) {
      return false;
    }
    return true;
  });
  const ceoMsg2 = contentIds.find((eachContent) => isCEOMsgContent(eachContent.url));
  updatedContentIds = updatedContentIds.map((eachContent) => {
    const { url: contentId } = eachContent;
    if (["about-partsavatar-canada-msg-from-ceo-1", "fr-about-partsavatar-canada-msg-from-ceo-1"].includes(contentId)) {
      return {
        ...eachContent,
        url: "about-partsavatar-canada-msg-from-ceo",
        uiDetails: {
          ...eachContent.uiDetails,
          content2: ceoMsg2.uiDetails.content,
        },
      };
    }
    return eachContent;
  });
  return (
    <div className={`about-us container p-5 ${styles.about_us_container}`}>

      <h1 className={commonTitleStyles.common_title}>{heading}</h1>

      <LandingPageBanner
        bannerImages={{
          mobileImage: getRelativeImagePath("/banners/mobile/about-partsavatar-canada.jpg"),
          desktopImage: getRelativeImagePath("/banners/about-partsavatar-canada.jpg"),
        }}
        alt="PartsAvatar"
      />

      {
        updatedContentIds.map((eachContent) => {
          const { url } = eachContent;
          const { content, content2 } = eachContent?.uiDetails || {};
          const { title, article } = content;

          return (
            <>
              <h1 className={commonSectionStyles.common_section}>{title}</h1>
              <div className="p-l-10 p-r-10">
                <AboutPartsAvatarItem contentId={url} htmlContent={article} htmlContent2={content2?.article} />
              </div>
            </>
          );
        })
      }
    </div>
  );
}

export default AboutPartsAvatar;
